<template>
  <l-map
    ref="map"
    style="position: relative; font-size:18px; height:900px; width: 100%; background-color:rgba(0, 0, 0, 0); color:#ffffff; z-index: 0;"
    :crs="crs"
    :min-zoom="minZoom4"
    :zoom="-1"
    :options="{scrollWheelZoom:false, zoomControl: false, doubleClickZoom: false, attributionControl:false,
               touchZoom: false, tap: false, dragging: false}"
  >
    <l-image-overlay
      :url="require('@/assets/images/icons/scada/drr-diagram/Rural-Roads.png')"
      :bounds="bounds4"
    />
    <l-marker
      v-if="items[0].volt_status === 0"
      :lat-lng="[692, -517]"
      :icon="iconTranformerF"
    />
    <l-marker
      v-else
      :lat-lng="[692, -517]"
      :icon="iconTranformerN"
    />
    <!-- GEN ----------------------------------------------------------->
    <l-marker
      v-if="(items[1].volt_status === 0)"
      :lat-lng="[718, -124]"
      :icon="iconGenF"
    />
    <l-marker
      v-else
      :lat-lng="[718, -124]"
      :icon="iconGenN"
    />
    <!-- SelectT ----------------------------------------------------------->
    <l-marker
      v-if="items[0].volt_status === 1"
      :lat-lng="[300, -148]"
      :icon="iconSelectT"
    />
    <l-marker
      v-else-if="items[1].volt_status === 1"
      :lat-lng="[300, -148]"
      :icon="iconSelectG"
    />
    <l-marker
      v-else
      :lat-lng="[300, -148]"
      :icon="iconSelectF"
    />
    <!-- Tranformer ล่าง ----------------------------------------------------------->
    <l-marker
      v-if="(items[3].volt_status === 0)"
      :lat-lng="[-110, -700]"
      :icon="iconTranformerBotF"
    />
    <l-marker
      v-else
      :lat-lng="[-110, -700]"
      :icon="iconTranformerBotN"
    />
    <!-- Load1 ----------------------------------------------------------->
    <l-marker
      v-if="(items[4].volt_status === 0)"
      :lat-lng="[-588, 254]"
      :icon="iconLoadF"
    />
    <l-marker
      v-else
      :lat-lng="[-588, 254]"
      :icon="iconLoadN"
    />
    <!-- Load2 ----------------------------------------------------------->
    <l-marker
      v-if="(items[5].volt_status === 0)"
      :lat-lng="[-588, 412]"
      :icon="iconLoadF"
    />
    <l-marker
      v-else
      :lat-lng="[-588, 412]"
      :icon="iconLoadN"
    />
    <!-- Load2 ----------------------------------------------------------->
    <l-marker
      v-if="(items[5].volt_status === 0)"
      :lat-lng="[-588, 560]"
      :icon="iconLoadF"
    />
    <l-marker
      v-else
      :lat-lng="[-588, 560]"
      :icon="iconLoadN"
    />
  </l-map>
</template>

<script>
/* eslint-disable global-require */
import {
  LMap, LImageOverlay,
  LMarker,
//   LIcon,
} from 'vue2-leaflet'
import { CRS, icon, Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    // LIcon,
  },
  data() {
    return {
      waydetail: '',
      bounds4: [[-900, 1400], [800, -1100]],
      iconSize: 64,
      crs: CRS.Simple,
      minZoom4: -1,
      deptid: '',
      markers: [],
      items: [],
      iconTranformerF: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/t1-y1.gif'),
        iconSize: [264, 276],
        iconAnchor: [16, 37],
      }),
      iconTranformerN: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/t1-b1.gif'),
        iconSize: [264, 276],
        iconAnchor: [16, 37],
      }),
      iconGenF: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/gen-y1.gif'),
        iconSize: [271, 288],
        iconAnchor: [16, 37],
      }),
      iconGenN: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/gen-b1.gif'),
        iconSize: [271, 288],
        iconAnchor: [16, 37],
      }),
      iconSelectT: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/ats-l-n1.gif'),
        iconSize: [116, 230],
        iconAnchor: [16, 37],
      }),
      iconSelectG: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/ats-r-n1.gif'),
        iconSize: [116, 230],
        iconAnchor: [16, 37],
      }),
      iconSelectF: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/ats-y1.gif'),
        iconSize: [116, 230],
        iconAnchor: [16, 37],
      }),
      iconTranformerBotF: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/tf-cb-n1.gif'),
        iconSize: [657, 240],
        iconAnchor: [16, 37],
      }),
      iconTranformerBotN: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/tf-cb-y1.gif'),
        iconSize: [657, 240],
        iconAnchor: [16, 37],
      }),
      iconLoadN: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/TTn1.png'),
        iconSize: [47, 80],
        iconAnchor: [16, 37],
      }),
      iconLoadF: icon({
        iconUrl: require('@/assets/images/icons/scada/drr-diagram/TTf1.png'),
        iconSize: [657, 240],
        iconAnchor: [16, 37],
      }),
      sem_type: '',
      diagram_type: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getValueDiagram()
    this.interval = setInterval(() => {
      this.getValueDiagram()
    }, 10000)
  },
  mounted() {
    this.$refs.map.mapObject.invalidateSize()
  },
  methods: {
    getValueDiagram() {
      axios
        .post('/getDiagram-PWT', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style  lang="scss" scoped>
</style>
